import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { constant } from '../../app.constants';
import { ParentService } from '../../pages/A2-utils/ParentClass/ParentService';
import { IConfiguration, IConfigurationRequest } from 'app/core/interfaces/configuration.interface';
import { IConfigurationHistoryRow } from 'app/core/interfaces/configuration-history.interface';
import { IQuestionType } from 'app/core/interfaces/question-type.interface';

@Injectable()
export class ConfigurationService extends ParentService {
  constructor(private _http: Http) {
    super();
  }

  getHistory(configurationId: number): Observable<IConfigurationHistoryRow[]> {
    return this._http
      .get(constant.URL_CONFIGURATION + '/' + configurationId + '/History', this.getHeader())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getActive(showInactive: boolean): Observable<IConfiguration[]> {
    return this._http
      .get(constant.URL_CONFIGURATION + '?showInactive=' + showInactive, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getQuestionTypes(): Observable<IQuestionType[]> {
    return this._http
      .get(constant.URL_CONFIGURATION + '/QuestionTypes', this.getHeader())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  create(data: IConfigurationRequest): Observable<IConfiguration> {
    const bodyString = JSON.stringify(data);
    return this._http
      .post(constant.URL_CONFIGURATION, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  update(configurationId: number, data: IConfigurationRequest): Observable<IConfiguration> {
    const bodyString = JSON.stringify(data);
    return this._http
      .put(constant.URL_CONFIGURATION + '/' + configurationId, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/administration/configuration.service.ts